import React from 'react';
import styled from 'styled-components';
import { colors, Container, Heading, InternalLink, AnimateIn, media } from '../ui-components';
import CONTENT from '../static-content/contact.json';

 /**
   * @component Contact
   * 
   * @param {object} props
   * 
   * @prop {string} headline
   * @prop {string} ctaLinkLabel
   * @prop {string} ctaLinkUrl 
   * 
   * @return {JSX}
   */
const Contact = props => {
  const { headline, ctaLinkLabel, ctaLinkUrl } = props;

  return (
    <>
      <ContactWrapper>
        <AnimateIn onScroll direction="none">
          <ContactContainer>
            <ContactHeading level={2}>{headline ? headline : CONTENT.CONTACT__HEADLINE}</ContactHeading>
            <InternalLink linkstyle="primary-button" to={ctaLinkUrl ? ctaLinkUrl : '/contact'}>
              {ctaLinkLabel ? ctaLinkLabel : CONTENT.CONTACT__CTA}
            </InternalLink>
          </ContactContainer>
        </AnimateIn>
      </ContactWrapper>
    </>
  );
};

const ContactWrapper = styled.div`
  background-color: ${colors.secondaryBackground};
  text-align: center;
`;

const ContactContainer = styled(Container)`
  padding-top: 80px;
  padding-bottom: 80px;

  @media screen and (max-width: ${media.mediumTop}) {
    padding-top: 60px;
    padding-bottom: 60px;
  }
`;

const ContactHeading = styled(props => <Heading {...props} />)`
  margin-bottom: 40px;
`;

export default Contact;
